<template>
  <div>

    <DataTable
        :filters="filters"
        :loading="loading"
        :paginator="true"
        :resizableColumns="true"
        :scrollable="true"
        :selection.sync="selection"
        sortField="originalTitle"
        :sortOrder="1"
        :style="gridStyle"
        lazy
        :rows="rows"
        :rowsPerPageOptions="[10, 25, 50, 100]"
        :value="dataRows.content"
        :totalRecords="dataRows.totalElements"
        v-on:page="pageEvent"
        v-on:sort="sortEvent"
        columnResizeMode="expand"
        dataKey="basemasterGUID"
        selection-mode="multiple"
        style="max-width: 100%!important;"
    >

      <Column v-if="featureActive('shoppingCard')" bodyClass="button-column" bodyStyle="text-align: center"
              headerStyle="width: 2.5em">
        <template #body="slotProps">
          <Button :disabled="isDisabled(slotProps.data)" class="p-button-secondary embedded-button" icon="pi pi-plus"
                  type="button" v-on:click="addToBasked(slotProps.data)"></Button>
        </template>
      </Column>

      <Column v-for="col of getCols"
              :key="col.key"
              :field="col.field"
              :filterFunction="customFilter"
              :header="col.header"
              :header-style="col.headerStyle"
              :sortable="true"
              body-style="height: 30px"
              body-class="table-data-nowrap"
              filterMatchMode="custom"
      >

        <template #filter>
          <InputText
              v-if="col.isTextFilter"
              type="text"
              v-model="filters[col.field]"
              v-on:input="inputEvent"
              class="p-column-filter"
              :placeholder="translate('placeholder.no.filter')"/>
          <DropDown
              v-if="col.isDropDownFilter"
              v-model="filters[col.field]"
              filter
              v-on:input="inputEvent"
              :options="filterOptions[col.field]"
              :placeholder="translate('placeholder.no.filter')"
              appendTo="body"
              class="p-column-filter"
              optionLabel="label"
              showClear
              styleClass="ui-column-filter"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value" class="p-dropdown-car-value">
                <span v-html="slotProps.value.label"></span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <div class="p-dropdown-car-option">
                <span v-html="slotProps.option.label"></span>
              </div>
            </template>
          </DropDown>
<!--          <component v-if="col.isCustomFilter" :is="col.customFilterComponent" :filters="filters" :col="col"></component>-->
          <FirstUsageDropDown v-else-if="col.isFirstUsageFilter"
                       v-model="filters[col.field]"
                              v-on:input="inputEvent"
          >

          </FirstUsageDropDown>
          <span
              v-if="col.isDateFilter"
              class="p-fluid p-column-filter translate-calendar">
            <Calendar
                v-model="filters[col.field]"
                v-on:input="inputEvent"
                appendTo="body"
                selectionMode="single"
                dateFormat="dd.mm.yy"
                showIcon
                :showTime="false"
            />
          </span>

        </template>
        <template #body="slotProps">
          <div v-html="col.getter(slotProps.data[col.field], col.field, slotProps.data)"></div>
        </template>
      </Column>
      <template #paginatorLeft>
        Count: {{ recordCount }}
      </template>
      <template #empty>
        {{ translate('no.records') }}
      </template>
    </DataTable>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TranslateService from "../services/translate.service";
import SearchFieldService from "@/services/searchfield.service";
// import FirstUsageDropDown from "@/components/FirstUsageDropDown.vue"
import _ from 'lodash';
import Vue from 'vue';
import FirstUsageDropDown from "@/components/FirstUsageDropDown.vue";

export default {
  name: "MultiAvailGrid",
  components: {FirstUsageDropDown},
  props: ['colDefinitions', 'dataRows', 'loading'],
  data() {
    return {
      filters: {},
      selection: null,
      rows: 10,
      filterOptions: {}
    }
  },
  methods: {
    ...mapActions('offer', ["addToOffer"]),

    inputEvent(event) {
      console.log("InputEvent: ", event);
      this.$emit("filterChanged", this.filters);
    },
    pageEvent(pageEvent) {
      this.$emit("page", pageEvent);
      // console.log('pageEvent ', pageEvent)
    },
    sortEvent(sortEvent) {
      console.log("sortevent", sortEvent);
      // this.$emit("sort", { sortOrder: getSortField(sortEvent) });
      this.$emit("sort", sortEvent);
    },

    translate(message) {
      return TranslateService.translateMessage(message);
    },
    addToBasked(item) {
      this.addToOffer(item);
      this.$toast.add({
        severity: 'success',
        summary: 'Production added to basket',
        detail: item.originalTitle,
        life: 1000
      });
    },

    contains(value, filter, filterLocale) {
      if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      // var filterValue = _ObjectUtils.default.removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
      var filterValue = filter.toString().toLocaleLowerCase(filterLocale);

      // var stringValue = _ObjectUtils.default.removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
      var stringValue = value.toString().toLocaleLowerCase(filterLocale);

      return stringValue.indexOf(filterValue) !== -1;
    },
    customFilter(value, filter) {
      if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      if (Object.prototype.hasOwnProperty.call(filter, 'key')) {
        return (filter.key === value);
      } else {
        return this.contains(value, filter);
      }
    },
    populateFilterOptions() {
      for (let col of this.getCols) {
        if (_.get(col, "isDropDownFilter", false)) {
          if (_.get(col, "searchFieldType", "STRING") === "LOOKUP") {
            SearchFieldService.loadLookupData(_.get(col, 'field')).then((r) => {
              let res = r.data;
              for (let r of res) {
                r.key = r.id;
              }

              Vue.set(this.filterOptions, col.field, res);
              // this.filterOptions[col.field] = res;
            });
          }
          if (_.get(col, "searchFieldType", "STRING") === "GLOBAL_TRAFFIC_LIGHT") {
            let res = [
              {id: "AVAILABLE", key: "AVAILABLE", label: "Available"},
              {id: "NOT_AVAILABLE", key: "NOT_AVAILABLE", label: "not Available"},
              {id: "TBA", key: "TBA", label: "TBA"},
            ]
            Vue.set(this.filterOptions, col.field, res);
          }
          // Falls wir das Multiselect wieder haben wollen?!?!?
          // if (_.get(col, "searchFieldType", "STRING") === "TRAFFIC_LIGHT") {
          //   let res = [
          //     {id: "AVAILABLE", key: "AVAILABLE", label: "Available"},
          //     {id: "AVAILABLE_FIRST_USAGE", key: "AVAILABLE_FIRST_USAGE", label: "Available (first usage)"},
          //     {id: "TBA", key: "TBA", label: "TBA"},
          //     {id: "TBA_FIRST_USAGE", key: "TBA_FIRST_USAGE", label: "TBA (first usage)"},
          //     {id: "NOT_AVAILABLE", key: "NOT_AVAILABLE", label: "not Available"},
          //   ]
          //   Vue.set(this.filterOptions, col.field, res);
          // }
        }
      }
    },
  },
  computed: {
    ...mapGetters('nav', ["getContentWidth"]),
    ...mapGetters('offer', ['getHasItem', 'getSet', 'getDirtyHackValue']),
    ...mapGetters('config', ['featureActive']),

    isDisabled: function () {
      let set = this.getSet;
      let v = this.getDirtyHackValue;
      return function (item) {
        console.log(v); // Ist wichtig damit der state von this.getDirtyHackValue in den Cache des Computet mit einfließt
        return set.has(item.basemasterGUID);
      };
    },

    getCols() {
      return this.colDefinitions;
    },
    recordCount() {
      // return this.dataRows.length;
      return this.dataRows.totalElements;
    },
    gridStyle() {
      return "width: " + this.getContentWidth + "px";
    }
  },
  watch: {
    selection: function () {
      this.$emit('selection', this.selection);
    },
    filters() {
      console.log("Filters Watcher")
      this.$emit("filterChanged", this.filters);
    },
    colDefinitions() {
      this.populateFilterOptions();
    }

  },
  mounted() {
    console.log("getCols",this.getCols)
  }
}
</script>

<style>
/*.p-dropdown {*/
/*    width: 12em;*/
/*}*/

.translate-calendar {
  display: inline-block;
  transform: translateX(-1.0em);
}

.p-dropdown-car-option,
.p-dropdown-car-value {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

img {
  margin-right: .5em;
  width: 24px;
}

span {
  margin-top: .125em;
}

.p-dropdown-car-value {
  justify-content: flex-start;
}

.p-dropdown-empty-car-token {
  background: #d95f00;
  color: #ffffff;
}

.button-column {
  padding: 0 !important;
}

.embedded-button
.p-button-text {
  padding: 0 !important;
}
</style>